import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useQuery } from './use-query';

export function useQueryParam<T>(queryName: string, defaultValue?: T): [T, (m: T, replace?: boolean) => void] {
    const history = useHistory();
    const query = useQuery();
    const location = useLocation();
    const modalParam = (query.get(queryName) || defaultValue || null) as T;
    const [q, setQ] = useState<T>(modalParam);

    useEffect(() => {
        const v = (query.get(queryName) || defaultValue || null) as T;
        setQ(v);
    }, [query]);

    const setQueryParam = (m: T, replace?: boolean) => {
        if (typeof m === 'string') {
            query.set(queryName, m);
        } else {
            query.delete(queryName);
        }
        if (replace) {
            history.replace({
                pathname: location.pathname,
                search: `?${query.toString()}`,
            });
        } else {
            history.push({
                pathname: location.pathname,
                search: `?${query.toString()}`,
            });
        }
        setQ(m);
    };

    return [q, setQueryParam];
}
